import { MultiSetTreeBuilder } from "./multi-set-tree-builder";
import { MultiSetTreeNode } from "./multi-set-tree-node";
import { MultiSetWordNode } from "./multi-set-word-node";

export abstract class MultiWordTreeBuilder extends MultiSetTreeBuilder {
    
    /**
     * Adds a MultiWordNode to the tree.
     */
    addTreeNode(row: number, col: number, content: any[], maxWidth?: number): MultiSetTreeNode {
        let node = new MultiSetWordNode(row, col, null, content, this.depth);
        if (maxWidth != undefined) {
            node.setMaxWidth(maxWidth);
        }
        return node;
    }

}
